import initCustomSelect from '../../components/custom-select';
import progress from '../../utils/progress';

/**
 *  Initializes the form submit event
 */
const initSubmitEvent = () => {
    const unsubscribeForm = document.querySelector('#newsletter-unsubscribe-form');
    unsubscribeForm.addEventListener('submit', () => {
        progress.show(unsubscribeForm);
    });
};

/* eslint-disable import/prefer-default-export */
/**
 * Initializes the newsletter opt-out components and events.
 */
export const init = () => {
    initCustomSelect();
    initSubmitEvent();
};
